import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ICON from 'components/cmp_icon/cmp_icon'

import TAB_DETAILS from './tab_details/crd_details/crd_details';

import './activity_details.css';



export default function ACTIVITY_DETAILS() {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { activity_id } = useParams();

    const [ var_tab, set_tab ] = useState('DETAILS');
    const [ var_activity_name, set_activity_name ] = useState('');



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_tab(tab){
        set_tab(tab)
    }



    // RENDER CONTAINER ================================================================================================

    return (
        <div id='page--activity_details' className='page'>

            <div className='page__header'>
                <div className='text--xl medium'>{var_activity_name}</div>
            </div>

            <div className='tab'>
                <div className={'tab__item' + (var_tab === 'DETAILS' ? ' active' : '')} onClick={()=>onClick_tab('DETAILS')}>
                    <ICON name='lightning' className='tab__item__icon' alt='activity icon'/>
                    <div className='text--base medium'>Details</div>
                </div>
            </div>


            <div className='tab__pages__wrapper'>

                {var_tab === 'DETAILS' &&
                    <TAB_DETAILS
                        activity_id={activity_id}
                        current_tab={var_tab}
                        set_activity_name={set_activity_name}
                    />
                }

            </div>

        </div>
    );

}